import axios from 'axios';
import FaceDetectionModel from '../../models/FaceDetectionModel';
import apiService from '../apiService';

export default async function getFaceDetections(
  eventId = '',
  system = '',
  searchString = '',
  pagination = {
    limit: 1,
    offset: 0,
    hasMore: true,
  },
  orderBy = 'guest_id',
  order = 'ASC',
) {
  try {
    let _return = {
      data: [],
      count: 0,
      pagination: pagination
    }

    const _ret = await axios({
      url: `${apiService.getUrl().faceRecognition}faceDetection/getFaceDetections?eventId=${eventId}&system=${system}&offset=${pagination.offset}&limit=${pagination.limit}&search=${searchString}&orderBy=${orderBy}&order=${order}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    _ret.data?.data?.data?.forEach(item => {
      if (item.detection !== '[null]') {
        _return.data.push(FaceDetectionModel({
          id: item.id,
          eventId: item.eventId,
          system: item.system,
          guestId: item.guestId,
          detection: item.detection,
        }));
      }
    });

    _return.count = _ret.data?.data?.count;

    _return.pagination = {
      limit: pagination.limit,
      offset: pagination.limit + pagination.offset,
      hasMore: _return.data.length < pagination.limit ? false : true
    };
    return _return;
  } catch (error) {
    console.log('Error getFaceDetections', error);
    throw error;
  }
}
